import { render, staticRenderFns } from "./countdown-digital.vue?vue&type=template&id=5a37ce54"
import script from "./countdown-digital.vue?vue&type=script&lang=js"
export * from "./countdown-digital.vue?vue&type=script&lang=js"
import style0 from "./countdown-digital.vue?vue&type=style&index=0&id=5a37ce54&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports